import primaryButton from '../../../../primary-button';

const dark = (params) => primaryButton.solidIcon.background.active.dark(params);

export default dark;
